import { Empty, Flex, Table, Tag } from "antd";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AllergenTagList } from "../../../components/AllergenTagList.tsx";
import { fitContent, noWrap } from "../../../styles/shared.styles.ts";
import { formatNumber } from "../../../utils/nutritionFormat.ts";
import { ComparePhotosButton } from "../ComparePhotosButton.tsx";
import { useIngredient } from "../IngredientContext.tsx";
import { type FlatLabelRow, flattenLabelRows, LABEL_INDENT_PX } from "../labelIngredientUtils.ts";
import { labelOrderColumn } from "../labelIngredient.styles.ts";

export const IngredientLabelIngredientsTab = () => {
  const { t, i18n } = useTranslation();
  const { ingredient } = useIngredient();
  const rows = useMemo(() => flattenLabelRows(ingredient.labelIngredients), [ingredient.labelIngredients]);

  return (
    <Flex gap="middle" vertical>
      <div>
        <ComparePhotosButton />
      </div>
      {rows.length === 0 ? (
        <Empty description={t("ingredients.labelIngredients.noIngredients")} />
      ) : (
        <Table<FlatLabelRow>
          bordered
          className={fitContent}
          columns={[
            {
              title: t("ingredients.labelIngredients.nameColumn"),
              key: "name",
              render: (_, row) => (
                <Flex align="center" gap="small" style={{ paddingLeft: row.depth * LABEL_INDENT_PX }}>
                  <Tag className={labelOrderColumn} color="volcano" variant="solid">
                    <strong>{row.order}</strong>
                  </Tag>
                  <span>{row.item.name}</span>
                </Flex>
              ),
            },
            {
              title: "%",
              key: "percentage",
              align: "right",
              render: (_, row) =>
                row.item.percentage != null ? (
                  <span className={noWrap}>{formatNumber(row.item.percentage, i18n.language)}%</span>
                ) : (
                  "\u2014"
                ),
            },
            {
              title: t("allergens.title"),
              key: "allergens",
              render: (_, row) => <AllergenTagList allergens={row.item.allergens} />,
            },
          ]}
          dataSource={rows}
          pagination={false}
          rowKey={(row) => row.item.id}
          size="small"
        />
      )}
    </Flex>
  );
};
